import { cn } from "@babybjorn/ui";
import { useEffect, useRef, type FC, type InputHTMLAttributes } from "react";
import Input from "../Input";
import * as s from "./SearchBar.module.scss";

type SearchProps = InputHTMLAttributes<HTMLInputElement> & {
	clearCallback?: () => void;
	clearLabel?: string;
	inputLabel?: string;
	squareBorder?: boolean;
	searchPlaceholder?: string;
	quickSearch?: boolean;
	quickSearchOpen?: boolean;
	variant?: "default" | "thin";
};

const SearchBar: FC<SearchProps> = (props) => {
	const {
		quickSearch = false,
		quickSearchOpen = false,
		searchPlaceholder,
		clearLabel,
		inputLabel,
		clearCallback,
		...rest
	} = props;
	const inputRef = useRef<HTMLInputElement | null>(null);

	const ClearButton = () => {
		return (
			<button
				onClick={() => {
					if (inputRef.current) inputRef.current.value = "";
					if (clearCallback) clearCallback();
				}}
				className={cn(s.clearButton, { [s.thin]: props.variant === "thin" })}
			>
				{clearLabel}
			</button>
		);
	};

	useEffect(() => {
		if (quickSearchOpen && inputRef.current) {
			inputRef.current.focus();
		}
	}, [quickSearchOpen]);

	return (
		<Input
			hiddenLabel={true}
			label={inputLabel}
			search
			placeholder={searchPlaceholder}
			className={cn(s.searchBar, {
				[s.quickSearch]: quickSearch,
				[s.quickSearchOpen]: quickSearchOpen,
			})}
			containerClassName={cn(s.searchBarInputContainer, {
				[s.quickSearch]: quickSearch,
				[s.quickSearchOpen]: quickSearchOpen,
			})}
			overlayElement={clearLabel ? <ClearButton /> : null}
			ref={inputRef}
			{...rest}
		/>
	);
};

export default SearchBar;
